import { readQueryParams } from "tsi-common-react/src/apps/reviews/history";
import {
    setFacetValues,
    setProductTypes,
} from "tsi-common-react/src/apps/reviews/reducers";
import { isoReviewsProductTypeID } from "tsi-common-react/src/models/nominals";
import { notEmpty, unique } from "tsi-common-react/src/utils/functional";

import { store } from "../../store";

/**
 * Init facet values from the URL
 */
const initialFacetValues = readQueryParams();
if (initialFacetValues.product_type_id) {
    const productIDs = `${initialFacetValues.product_type_id}`
        .split(",")
        .map((ptid) => {
            return ptid
                ? isoReviewsProductTypeID.wrap(parseInt(ptid, 10))
                : null;
        })
        .filter(notEmpty)
        .filter(unique);
    if (productIDs.length) {
        store.dispatch(setProductTypes(productIDs));
    }
}

delete initialFacetValues.product_type_id;
store.dispatch(setFacetValues(initialFacetValues));
